export const getEnvironment = (key: string): string | undefined => {
    return process.env[key] ?? window.app_env?.[key];
};
